import { render, staticRenderFns } from "./CourseDiscuss.vue?vue&type=template&id=49ba0744&scoped=true"
import script from "./CourseDiscuss.vue?vue&type=script&lang=js"
export * from "./CourseDiscuss.vue?vue&type=script&lang=js"
import style0 from "./CourseDiscuss.vue?vue&type=style&index=0&id=49ba0744&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ba0744",
  null
  
)

export default component.exports